import React from 'react';
import { LandingSections, LandingTopMenu } from './LandingSections';

export default function LandingPage() {
  return (
    <div className="landing-page">
      <LandingTopMenu />
      <LandingSections />
    </div>
  );
}
